module.exports = __webpack_public_path__ + "static/media/fontsize.5d8631c8.svg";